import { render } from "./EtkinliklerView.vue?vue&type=template&id=748bc15a"
import script from "./EtkinliklerView.vue?vue&type=script&lang=js"
export * from "./EtkinliklerView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__